<template>
    <div class="d-flex flex-grow-1 flex-column">
    <v-dialog
  v-model="Passwordmodal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      style="border-radius: 0px !important;"
      class="subtitlefont password"
      id="password"

    >
      <v-card style="border-radius: 0px !important;">
        <v-toolbar color="FFF" style="text-align:center" >
            <v-row>
              <v-col cols="12" style="text-align:center;padding-top: 31px;">
            <label style="color:rgb(25, 118, 210);font-size:18px">Please Enter Password</label>
            </v-col>
            </v-row>

        </v-toolbar>
        <v-card-text
          style="font-size: 12px !important;"
        >
       <v-row >
        <v-col cols="12" style="padding-right: 11px;padding-top: 31px;
    padding-left: 11px;padding-bottom:0px
">
        <v-text-field
            label="Password"
            name="Password"
            outlined
            v-model="password"
             :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          
            :type="showPassword ? 'text' : 'password'"
           
            @click:append="showPassword = !showPassword"
          
          ></v-text-field>
        </v-col>
       </v-row>
     
          <v-row no-gutters>
            <v-col
              cols="12"
              md="12"
              sm="12"

              style="
                padding-top: 4px !important;
                padding-bottom: 0px !important;
              "
            >
          <v-btn
           
            block
            x-large
            color="primary"
             @click="signIn"
            
          >login</v-btn>
            </v-col>

          </v-row>
      
        </v-card-text>
      </v-card>
    </v-dialog>

  <v-snackbar Bottom :timeout="timeout" color="green"  v-model="snackbar">
        {{ SnackbarMessege }}
      </v-snackbar> 
      </div>
  </template>
  <script>
     import axios from "axios";
  export default {
    data() {
      return {
        Name: "Smart Collector",
    Passwordmodal:true,
    snackbar: false,
    SnackbarMessege: '',
    timeout: 2000,
     errorMessages: '',
      password:'',
    showPassword: false,
     // form error
      error: false,
      };
    },
    created(){
           
              
    },
    mounted()
    {
        this.UserObject = JSON.parse( localStorage.getItem('User'))
    },
    methods: {
    resetErrors() {
      this.error = false
      this.errorMessages = ''

      this.errorProvider = false
      this.errorProviderMessages = ''
    },
    
    signIn() {
      this.UserData = {}
       this.bURL = localStorage.getItem('BaseURL'),
      this.UserData.Username = this.UserObject.username
      this.UserData.Password = this.password
      this.UserData.VersionCode = 2
      this.isLoading = true
      this.isSignInDisabled = true
      axios.post(this.bURL + '/api/user/authenticate?IsBlockMultipleLogin=false&IsCreateToken=true',this.UserData)
        .then((response)  =>  {
          if (response.status === 200)
          {
            this.isLoading = false
            this.isSignInDisabled = false
            localStorage.setItem('Token',response.data.token)
            location.reload()

          }

        },
        (error)  =>  {
          console.log(error)
          this.isLoading = false
          this.isSignInDisabled = false
          if(error.response === undefined)
          {
            this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
          }
          else if(error.response.data !=="")
          {
            this.SnackbarMessege = error.response.data
          }
           else{
             this.SnackbarMessege = this.$t(`menu.CheckyourInternetConnection`)
           }
          this.snackbar = true
        })

    },
    },
    computed: {
    
    },
    
  };
  </script>
  